import React from "react";
import { Box, Typography, SxProps } from "@mui/material";
import BSWLogo from "./BSWLogo";

interface TranslationHubLogoProps {
  iconSrc?: string;
  translationIconSize?: number;
  BSWlogoWidth?: number;
  BSWlogoHeight?: number;
  titleVariant?: "h4" | "h5" | "h6";
  subtitleVariant?: "subtitle1" | "subtitle2" | "body1";
  titleSx?: SxProps;
  subtitleSx?: SxProps;
  containerSx?: SxProps;
}

const TranslationHubLogo: React.FC<TranslationHubLogoProps> = ({
  iconSrc = "/images/translation.png",
  translationIconSize = 50,
  titleVariant = "h5",
  subtitleVariant = "subtitle2",
  titleSx = {},
  subtitleSx = {},
  containerSx = {},
}) => {
  return (
    <Box sx={{ ...styles.container, ...containerSx }}>
      <Box
        component="img"
        src={iconSrc}
        alt="Translation Hub Icon"
        sx={{
          ...styles.translationIcon,
          width: translationIconSize,
          height: translationIconSize,
        }}
      />
      <Box>
        {/* Title */}
        <Typography
          variant={titleVariant}
          sx={{
            ...styles.title,
            ...titleSx,
          }}
        >
          Translation Hub
        </Typography>

        {/* Subtitle + Logo */}
        <Box sx={styles.subtitleContainer}>
          <Typography
            variant={subtitleVariant}
            sx={{
              ...styles.subtitle,
              ...subtitleSx,
            }}
            component={'span'}
          >
            for
          </Typography>
          <BSWLogo height={20}/>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  translationIcon: {
    objectFit: "contain",
  },
  title: {
    fontWeight: 600,
    fontSize: '2rem',
    color: "#364248",
  },
  subtitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  subtitle: {
    fontWeight: 400,
    color: "#364248",
  },
};

export default TranslationHubLogo;
